import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return "Something went wrong. Please try again.";
}

export const rupee = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

const CATEGORY_IMG = {
  grocery: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400",
  "personal-care": "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400",
  household: "https://images.unsplash.com/photo-1583947215259-38e31be8751f?w=400",
  beverages: "https://images.unsplash.com/photo-1544145945-f90425340c7e?w=400",
  snacks: "https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=400",
  "fruits-vegetables": "https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=400",
  dairy: "https://images.unsplash.com/photo-1563636619-e9143da7973b?w=400",
  bakery: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=400",
  beauty: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400",
  "baby-care": "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400",
  "pet-care": "https://images.unsplash.com/photo-1589924691995-400dc9ecc119?w=400",
  stationery: "https://images.unsplash.com/photo-1456735190827-d1262f71b8a3?w=400",
};
const GENERIC_IMG = "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400";

export const imgSrc = (url, category) => {
  if (!url) return CATEGORY_IMG[category] || GENERIC_IMG;
  if (url.startsWith("/")) return `${BASE}${url}`;
  return url;
};
export const placeholderFor = (category) => CATEGORY_IMG[category] || GENERIC_IMG;

export default api;
